<template>
  <CRow>
    <CCol col="4" >
    <CCard>   
    <CCardHeader><b>Personal Info</b> </CCardHeader>
      
      <CListGroup >
        <CListGroupItem href="#"> Name :  {{ datas.data.fullname }} </CListGroupItem>
        <CListGroupItem href="#"> Email :  {{ datas.data.email }} </CListGroupItem>
        <CListGroupItem href="#"> Gender :  {{ datas.data.gender }} </CListGroupItem>
        <CListGroupItem href="#"> Teacher :  {{ datas.data.teacher_name }} </CListGroupItem>
        
      </CListGroup>
    </CCard>
    <CCard>   
    <CCardHeader><b>Result</b></CCardHeader>
      <CListGroup >
        <CListGroupItem v-for="item in datas.data.total_result " :key="item.id">
        <div>
        <CRow>
          <CCol class="col-10">
          {{ item.hasil }}
          </CCol>
          
          
          <CCol class="col-2">
          {{  item.nilai}}
          </CCol>
        </CRow>
        </div>
        </CListGroupItem>  
         </CListGroup>
    </CCard>
    </CCol>
    <CCol col="8" >
      <CCard>
         <CCardHeader><b>Answer Detail</b></CCardHeader>
          <CCardBody>
            
            <!-- <label>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</label> -->
              
                <table class="mt-3">
                <thead>
                  <tr >
                    <th v-for="item in fields_answer" :key="item.title">
                    {{ item.title }}
                    </th>
                  </tr>
                </thead>
              <tbody>
                <tr style="border-bottom:1px solid grey " v-for="i in datas.data.get_answer" :key="i.id" >
                  <td >{{ i.question }} 
                    
                  </td>
                  <td>{{ i.answer }}</td>
                   </tr>
              </tbody>
              </table>

            
          </CCardBody>
        </CCard>
    </CCol>
 
    <alertmodal></alertmodal>
  </CRow>

</template>

<script>  
import moment from 'moment';
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import onlineclass from '@/services/onlineclass';
import report from '@/services/report';

import ikid from '@/services/ikid'
import axios from 'axios'

import store from '@/store.js'

export default {
name: 'detailmodal',
components: {  alertmodal },
  data () {
    return {
      accordion: '',
      mode: '',
      datas:[],
      dob:'',
      dad:'',
      mom:'',
      form:{
        uuid:''
      },
      fields_answer:[ 
        {title: 'Question', sortable: false, },
        {title: 'Answer', sortable: false},
      ],
      }
  },
  mounted(){
    this.load()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.load();
          console.log('load mounted')  
      }
    });
  },  
  
  beforeDestroy(){
    EventBus.$off('TABLE_UPDATE', this.listener)  
    console.log('OFF_OPEN_MODAL_IKID')
   },
 methods:{

   
   getPhoto(data){
      console.log('get - photo')
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    },    
    openModalEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load edit-detail-ikid')
       
    },
    openModalEditPhoto(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid Photo', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_PHOTO', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load edit photo')
        
    },
    openModalEditNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Kid Note', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_NOTE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load edit note')
    },
    openModalNewNote(){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'New Kid Note', mode:'create'}
        EventBus.$emit('OPEN_MODAL_IKID_NOTE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
        console.log('load new note')
    },
    destroyNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete kid note') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete this note?")){
        ikid.deleteIkidNote(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          
          console.log('load delete note')
        })
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
      } 
    },
    load(){
      console.log('load ikidbyid')
        onlineclass.getKaruniaRohanibyID(this.$route.query.id)
        .then(res => {
            this.datas = res;
            
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

        
        
    },
   
    
  }  
}

</script>
